<!--
 * @Description:
 * @Date: 2023-05-19 16:35:52
-->
<template>
  <div class="box">
    <el-form :model="formParams" ref="form" label-position="top">
      <div
        class="flex"
        v-for="{ title, subTitle, list } in form.filter(i => !i.hide)"
        :key="title"
      >
        <div class="app-detail-item-title">
          <span>{{ title }}</span>
          <span
            style="font-size: 12px;margin-top: 4px;margin-left: 5px;color:#9c9c9c;"
          >
            {{ subTitle }}
          </span>
        </div>
        <el-form-item
          :label="item.label"
          v-for="item in list"
          :label-width="item.label ? '130px' : '0'"
          :style="{ width: item.width }"
          :key="item.key"
          :prop="item.key"
          :rules="item.rules || []"
        >
          <template v-if="item.slot === 'dicSelect'">
            <dic-select
              :defaultActive="item.attrs.defaultActive"
              :prop="item.attrs.prop"
              style="width:100%;"
              :key="dicSelectKeys[item.key]"
              @dic-select-obj="
                val => {
                  item.callback && item.callback(val);
                  formParams[item.key] = val[item.attrs.useValueKey];
                  item.key1 &&
                    item.attrs.useValueKey1 &&
                    (formParams[item.key1] = val[item.attrs.useValueKey1]);
                }
              "
              :fuzzyDef="item.selectAjax"
              v-bind="item.attrs"
              :placeholder="item.placeholder"
              class="data-item"
            ></dic-select>
          </template>
          <template v-if="item.slot === 'input'">
            <el-tooltip
              class="item"
              effect="dark"
              :content="formParams[item.key]"
              :disabled="!(item.attrs || {}).disabled || !formParams[item.key]"
              placement="top-start"
            >
              <el-input
                :placeholder="item.placeholder"
                v-model="formParams[item.key]"
                v-bind="item.attrs"
                v-on="item.listeners"
                class="data-item"
              />
            </el-tooltip>
          </template>
          <template v-if="item.slot === 'date'">
            <el-date-picker
              :placeholder="item.placeholder"
              :value-format="item.valueFormat"
              v-model="formParams[item.key]"
              class="data-item"
              :type="item.type || 'month'"
              v-bind="item.attrs"
              v-on="item.listener"
            ></el-date-picker>
          </template>
          <template v-if="item.slot === 'custom'">
            <component
              :ref="item.ref"
              :is="item.component"
              :value="formParams[item.key]"
              v-bind="item.attrs"
              v-on="item.listeners"
            ></component>
          </template>
          <component
            v-if="item.otherCustom"
            :is="item.otherCustom.component"
            v-bind="item.otherCustom.attrs"
            v-on="item.otherCustom.listeners"
          ></component>
        </el-form-item>
      </div>
    </el-form>
    <div style="text-align: center;padding-bottom:15px;">
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="$xrkDialog.remove()">
        取消
      </el-button>
    </div>
  </div>
</template>

<script>
import { moneyInt } from '@/tools/money';
import { invoiceNew } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
import invoiceInfoList from './invoiceInfoList';
import wuliuInfo from './wuliuInfo.vue';
import uploadFile from './uploadFile.vue';
import uploadImg from './uploadImg.vue';

export default {
  name: 'add-dutypaid-proof',
  components: { dicSelect },
  props: { id: [Number, String], isLook: [Boolean], isAdd: [Boolean] },
  data() {
    return {
      dicSelectKeys: {
        itemId: 1
      },
      formParams: {
        itemId: '',
        invoiceType: '',
        invoiceAmount: '',
        addInvoiceApply: '',
        gongyeEnterpriseId: '',
        receiptFullName: '',
        receiptPhone: '',
        receiptAddress: '',
        enterpriseName: '',
        invoiceIdentifierNo: '',
        invoicePhone: '',
        invoiceOpenBank: '',
        invoiceBankNo: '',
        invoiceEnterpriseAddress: '',
        csoEnterpriseId: '',
        picList: [],
        fileList: [],
        address: []
      },
      hasOwnEnterpriseList: false
    };
  },
  computed: {
    form() {
      const {
        $refs,
        formParams,
        isLook,
        isAdd,
        hasOwnEnterpriseList,
        $xrkDialog,
        $createElement,
        formParams: { picList = [] }
      } = this;
      const checkNumber = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('不能为空'));
        } else if (isNaN(value)) {
          callback(new Error('请填写数字'));
        } else if (!/^(\d+|\d+\.\d{1,2})$/.test(`${value}`)) {
          callback(new Error('最多填写两位小数'));
        } else {
          callback();
        }
      };
      const selectRequired = [
        { required: true, message: '请选择内容', trigger: 'change' }
      ];
      const inputRequired = [
        { required: true, message: '请输入内容', trigger: 'change' }
      ];
      return [
        {
          title: '开票信息',
          list: [
            {
              label: '发票抬头',
              slot: 'dicSelect',
              key: 'enterpriseName',
              selectAjax: invoiceNew.getGongyeEnterprise,
              callback: info => {
                formParams.gongyeEnterpriseId = info.gongyeEnterpriseId;
                formParams.enterpriseName = info.gongyeEnterpriseName;
                formParams.addInvoiceApply = info.gongyeEnterpriseName;
                formParams.invoiceTitle = info.gongyeEnterpriseName;
                formParams.receiptFullName = info.receiveName;
                formParams.receiptPhone = info.receivePhone;
                formParams.receiptAddress = info.mailAddress;
                formParams.invoiceIdentifierNo =
                  info.gongyeEnterpriseIdentifierNo;
                formParams.invoicePhone = info.enterprisePhone;
                formParams.invoiceOpenBank = info.openBank;
                formParams.invoiceBankNo = info.bankNo;
                formParams.invoiceEnterpriseAddress =
                  info.gongyeEnterpriseAddress;
              },
              attrs: {
                defaultActive: {
                  gongyeEnterpriseName: formParams['enterpriseName'],
                  gongyeEnterpriseId: formParams['gongyeEnterpriseId']
                },
                useValueKey: 'gongyeEnterpriseName',
                prop: {
                  label: 'gongyeEnterpriseName',
                  code: 'gongyeEnterpriseId'
                },
                ajaxQuery: 'keyWord'
              },
              rules: selectRequired
            },

            {
              label: '纳税人识别号',
              slot: 'input',
              key: 'invoiceIdentifierNo',
              attrs: {
                disabled: true
              }
            },
            {
              label: '联系电话',
              slot: 'input',
              key: 'invoicePhone',
              attrs: {
                disabled: true
              }
            },
            {
              label: '开户银行',
              slot: 'input',
              key: 'invoiceOpenBank',
              attrs: {
                disabled: true
              }
            },
            {
              label: '银行账号',
              slot: 'input',
              key: 'invoiceBankNo',
              attrs: {
                disabled: true
              }
            },
            {
              label: '企业地址',
              slot: 'input',
              key: 'invoiceEnterpriseAddress',
              attrs: {
                disabled: true
              }
            }
          ]
        },
        {
          title: '开票内容',
          list: [
            {
              label: '开票金额（元）',
              slot: 'input',
              key: 'invoiceAmount',
              attrs: {
                maxlength: 12
              },
              rules: [
                {
                  validator: checkNumber,
                  trigger: 'change'
                },
                ...inputRequired
              ]
            },
            {
              label: '发票类别',
              slot: 'dicSelect',
              key: 'invoiceType',
              key1: 'invoiceTypeName',
              selectAjax: () => {
                return new Promise(resolve => {
                  resolve({
                    data: {
                      data: [
                        {
                          label: '增值税普通发票',
                          key: 1
                        },
                        {
                          label: '增值税专用发票',
                          key: 2
                        }
                      ]
                    }
                  });
                });
              },
              attrs: {
                defaultActive: {
                  label: formParams.invoiceTypeName,
                  key: formParams.invoiceType
                },
                useValueKey: 'key',
                useValueKey1: 'label',
                prop: {
                  label: 'label',
                  code: 'key'
                }
              },
              rules: selectRequired
            },
            {
              label: '开票类目',
              slot: 'dicSelect',
              key: 'itemId',
              key1: 'itemName',
              selectAjax: invoiceNew.getCsoInvoiceCate,
              attrs: {
                useValueKey: 'id',
                useValueKey1: 'itemName',
                prop: {
                  label: 'itemName',
                  code: 'id'
                },
                defaultActive: {
                  itemName: formParams.itemName,
                  id: formParams.itemId
                },
                ajaxQuery: 'itemName',
                ajaxQueryObj: {
                  csoId: formParams.csoEnterpriseId
                }
              },
              rules: selectRequired
            },
            {
              label: '结算月度',
              slot: 'date',
              key: 'taskDt',
              valueFormat: 'yyyy-MM',
              rules: selectRequired
            }
          ]
        },
        {
          title: '发票邮寄地址',
          list: [
            {
              label: '收件人',
              slot: 'input',
              key: 'receiptFullName',
              attrs: {
                disabled: true
              }
            },
            {
              label: '联系电话',
              slot: 'input',
              key: 'receiptPhone',
              attrs: {
                disabled: true
              }
            },
            {
              label: '邮寄地址',
              slot: 'input',
              key: 'receiptAddress',
              attrs: {
                disabled: true
              }
            }
          ]
        },
        {
          title: '上传发票',
          list: [
            {
              width: '100%',
              slot: 'custom',
              key: 'picList',
              component: {
                render() {
                  return (
                    <uploadImg
                      disabled={isLook}
                      info={{
                        invoiceImgUrl: picList
                      }}
                      onSuccess={picList => {
                        formParams.picList = picList;
                      }}
                    ></uploadImg>
                  );
                }
              }
            }
          ]
        },
        {
          title: '上传附件',
          list: [
            {
              width: '100%',
              slot: 'custom',
              key: 'fileList',
              component: {
                render() {
                  return (
                    <uploadFile
                      disabled={isLook}
                      fileList={formParams.fileList.map(i => ({
                        name: i.fileName || i.name,
                        url: i.fileUrl || i.url
                      }))}
                      onSuccess={fileList => {
                        formParams.fileList = fileList;
                      }}
                    ></uploadFile>
                  );
                }
              }
            }
          ]
        }
        // {
        //   title: '物流信息',
        //   hide: isAdd,
        //   list: [
        //     {
        //       width: '100%',
        //       slot: 'custom',
        //       key: 'fileList',
        //       component: {
        //         render() {
        //           return (
        //             <wuliuInfo
        //               disabled={isLook}
        //               info={{
        //                 trackingNo: formParams.trackingNo,
        //                 companyCode: formParams.companyCode,
        //                 companyName: formParams.companyName,
        //                 isMail: +(formParams.isMail || 0)
        //               }}
        //               onChange={v => {
        //                 Object.entries(v).forEach(i => {
        //                   formParams[i[0]] = i[1];
        //                 });
        //               }}
        //             ></wuliuInfo>
        //           );
        //         }
        //       }
        //     }
        //   ]
        // }
      ];
    }
  },

  methods: {
    save() {
      if (this.formParams.picList.length == 0) {
        this.$message.error('发票不能为空');
        return;
      }
      if (this.formParams.picList.find(item => !item.invoiceNo)) {
        this.$message.error('发票编号不能为空');
        return;
      }
      this.$refs['form'].validate(vaild => {
        if (vaild) {
          let params = {
            id: this.id,
            ...this.formParams,
            fileList: this.formParams.fileList.map(i => ({
              fileName: i.fileName || i.name,
              fileUrl: i.fileUrl || i.url
            })),
            imgList: this.formParams.picList,
            // invoiceAmount: parseInt(this.formParams.invoiceAmount * 100)
            invoiceAmount: Math.round(this.formParams.invoiceAmount * 100)
          };
          invoiceNew['addInvoiceApply'](params).then(res => {
            this.$emit('confirm');
            this.$message.success('保存成功');
            // this.$xrkDialog.remove();
          });
        }
      });
    },
    // 获取当前时间
    getdatatime() {
      let date = new Date(Date.now());
      let dateStr = `${date.getFullYear()}-${
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : '0' + (date.getMonth() + 1)
      }`;
      this.$set(this.formParams, 'taskDt', dateStr);
    },
    async getInvioceInfo() {
      const {
        data: { data }
      } = await invoiceNew.detail({ id: this.id });
      const {
        invoiceTypeName,
        itemName,
        csoEnterpriseName,
        invoiceAmount,
        receiptFullName,
        receiptPhone,
        receiptAddress,
        enterpriseName,
        invoiceIdentifierNo,
        invoicePhone,
        invoiceOpenBank,
        invoiceBankNo,
        invoiceEnterpriseAddress,
        fileList,
        picList,
        imgList
      } = data;
      this.formParams = {
        ...data,
        invoiceTypeName,
        itemName,
        csoEnterpriseName,
        invoiceAmount: moneyInt(invoiceAmount),
        receiptFullName,
        receiptPhone,
        receiptAddress,
        enterpriseName,
        invoiceIdentifierNo,
        invoicePhone,
        invoiceOpenBank,
        invoiceBankNo,
        invoiceEnterpriseAddress,
        fileList: (fileList || []).filter(i => i),
        imgList: imgList || picList || [],
        picList: imgList || picList || []
      };
    }
  },
  async created() {
    !this.isAdd && this.getInvioceInfo();
    const {
      data: { data }
    } = await invoiceNew.getGongyeEnterprise();
    this.hasOwnEnterpriseList = (data || []).length > 0;
  },
  mounted() {
    this.getdatatime();
  }
};
</script>
<style lang="scss" scoped>
.box {
  .flex {
    display: flex;
    flex-wrap: wrap;
    .app-detail-item-title {
      font-size: 18px;
      width: 100%;
      margin-bottom: 30px;
    }
  }
  .el-form {
    &-item {
      width: 250px;
      margin-bottom: 25px;
      margin-right: 25px;
    }
  }
}
</style>
